import React from 'react';
import { Text, TextVariant } from '@naf/text';
import { TextList, TextListItem } from '@naf/text-list';
import { ProductID } from '@lib/ProductID';
import { useHouseholdMembers } from '@hooks/useHouseholdMembers';
import useSelector from '@redux/typedHooks';

export const MembershipOverview = () => {
  const { membership, services } = useSelector((state) => state.myMembership.customerInformation.data);
  const householdMembers = useHouseholdMembers();

  const hasMc = !!services?.find((service) => service.product?.id === ProductID.MC);
  const hasRoadSideAssistance = services?.find((service) => service.product?.id === ProductID.RoadSideAssistance);
  const showOverview = householdMembers.length > 0 || hasMc;

  if (!showOverview) {
    return null;
  }

  return (
    <div>
      <Text variant={TextVariant.ArticleTextLargeHeader}>Oppsigelsen gjelder:</Text>
      <Text variant={TextVariant.ArticleText}>{membership?.product?.name}</Text>
      {householdMembers.length > 0 && (
        <>
          <Text variant={TextVariant.ArticleText}>{`Husstandsmedlem${
            hasRoadSideAssistance ? ' med veihjelp' : ''
          }`}</Text>
          <TextList variant="bullet">
            {householdMembers.map((householdMember) => (
              <TextListItem key={householdMember.customerId}>{householdMember.fullName}</TextListItem>
            ))}
          </TextList>
        </>
      )}
      {hasMc && (
        <Text variant={TextVariant.ArticleText}>{`MC-medlemskap${hasRoadSideAssistance ? ' med veihjelp' : ''}`}</Text>
      )}
    </div>
  );
};

export const MembershipOverviewSerializer = () => () => <MembershipOverview />;
